export enum RecordingAction {
  Start = 'Start',
  Stop = 'Stop',
  Pause = 'Pause',
  Resume = 'Resume',
}

export enum RecordingType {
  Premise = 'premise',
  Cloud = 'cloud',
}
